import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Homepage } from 'src/app/Models/homepage';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css'],
  providers: [DatePipe]
})
export class HomepageComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: Homepage;
    isSpinning = false
  logtext:string = "";
  BANNER1_IMAGE_URL: File = null
  BANNER2_IMAGE_URL: File = null
  BANNER3_IMAGE_URL: File = null
 
  isokfile:boolean
 date = new Date();
 date11 = this.datePipe.transform(this.date, 'yyyyMMdd')
fileDataBANNER1_IMAGE_URL:File=null
 folderName= "BannerImages"

  datee = new Date();
 date1 = this.datePipe.transform(this.date, 'yyyyMMdd')
fileDataBANNER2_IMAGE_URL:File=null
 folderName1= "BannerImages"

  dates = new Date();
 date2= this.datePipe.transform(this.date, 'yyyyMMdd')
fileDataBANNER3_IMAGE_URL:File=null
 folderName2= "BannerImages"
  constructor(private api: ApiService, private message: NzNotificationService,private datePipe:DatePipe) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - Homepage form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {

  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {

 var isOk = true
    if (this.data.BANNER1_TITLE == undefined || this.data.BANNER1_TITLE=="") {
      this.message.error("Please Enter Banner1 Title" , "");
      isOk = false
    }
    if (this.data.BANNER2_TITLE == undefined || this.data.BANNER2_TITLE=="") {
      this.message.error("Please Enter Banner2 Title" , "");
      isOk = false
    }
    if (this.data.BANNER3_TITLE == undefined || this.data.BANNER3_TITLE=="") {
      this.message.error("Please Enter Banner3 Title" , "");
      isOk = false
    }
    if (this.data.DESCRIPTION == undefined || this.data.DESCRIPTION=="") {
      this.message.error("Please Enter Description" , "");
      isOk = false
    }
    if (this.data.EVENT_LIST == undefined || this.data.EVENT_LIST=="") {
      this.message.error("Please Enter Event List" , "");
      isOk = false
    }
    if(isOk)
    {

    
    this.isSpinning = true;
  
      if (this.data.ID) {

	 if (this.fileDataBANNER1_IMAGE_URL) {
 if (this.data.BANNER1_IMAGE_URL == "") {
  this.data.BANNER1_IMAGE_URL = this.genarateKeyBANNER1_IMAGE_URL();
}
   else {
 var str = this.data.BANNER1_IMAGE_URL.substring(this.data.BANNER1_IMAGE_URL.lastIndexOf('/') + 1).split('.')
    var fileExt = this.fileDataBANNER1_IMAGE_URL.name.split('.').pop();
  var url = str[0] + "." + fileExt;
   this.api.onUpload(this.folderName, this.fileDataBANNER1_IMAGE_URL, url)
  //  this.data.BANNER1_IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
  this.data.BANNER1_IMAGE_URL=url
 }
  }
 else { 
 this.data.BANNER1_IMAGE_URL = ""
  } if (this.fileDataBANNER2_IMAGE_URL) {
 if (this.data.BANNER2_IMAGE_URL == "") {
  this.data.BANNER2_IMAGE_URL = this.genarateKeyBANNER2_IMAGE_URL();
  
}
   else {
 var str = this.data.BANNER2_IMAGE_URL.substring(this.data.BANNER2_IMAGE_URL.lastIndexOf('/') + 1).split('.')
    var fileExt = this.fileDataBANNER2_IMAGE_URL.name.split('.').pop();
  var url = str[0] + "." + fileExt;
   this.api.onUpload(this.folderName, this.fileDataBANNER2_IMAGE_URL, url)
  // this.data.BANNER2_IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
  this.data.BANNER2_IMAGE_URL=url
 }
  }
 else { 
 this.data.BANNER2_IMAGE_URL = ""
  } if (this.fileDataBANNER3_IMAGE_URL) {
 if (this.data.BANNER3_IMAGE_URL == "") {
  this.data.BANNER3_IMAGE_URL = this.genarateKeyBANNER3_IMAGE_URL();
}
   else {
 var str = this.data.BANNER3_IMAGE_URL.substring(this.data.BANNER3_IMAGE_URL.lastIndexOf('/') + 1).split('.')
    var fileExt = this.fileDataBANNER3_IMAGE_URL.name.split('.').pop();
  var url = str[0] + "." + fileExt;
   this.api.onUpload(this.folderName, this.fileDataBANNER3_IMAGE_URL, url)
  // this.data.BANNER3_IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
  this.data.BANNER3_IMAGE_URL=url
 }
  }
 else { 
 this.data.BANNER3_IMAGE_URL = ""
  }

        this.api.updateHomepage(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Homepage information updated Successfully...", "");
              this.data.BANNER1_IMAGE_URL=null
              this.data.BANNER2_IMAGE_URL=null
              this.data.BANNER3_IMAGE_URL=null

	this.logtext = 'Update & Close - Homepage form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Homepage ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - Homepage form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Homepage ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update homepage information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {
 if (this.fileDataBANNER1_IMAGE_URL) {
 this.data.BANNER1_IMAGE_URL = this.genarateKeyBANNER1_IMAGE_URL()
}
  else {
  this.data.BANNER1_IMAGE_URL = "";
 }
  if (this.fileDataBANNER2_IMAGE_URL) {
 this.data.BANNER2_IMAGE_URL = this.genarateKeyBANNER2_IMAGE_URL()
}
  else {
  this.data.BANNER2_IMAGE_URL = "";
 } if (this.fileDataBANNER3_IMAGE_URL) {
 this.data.BANNER3_IMAGE_URL = this.genarateKeyBANNER3_IMAGE_URL()
}
  else {
  this.data.BANNER3_IMAGE_URL = "";
 }
        this.api.createHomepage(this.data)
          .subscribe(successCode => {
            this.BANNER1_IMAGE_URL=null
            this.BANNER2_IMAGE_URL=null
            this.BANNER3_IMAGE_URL=null
            if (successCode['code'] == "200") {
             
              this.message.success("Homepage information added successfully...", "");
              

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - Homepage form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Homepage ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new Homepage();
	this.logtext = 'Save & New - Homepage form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Homepage ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add homepage information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - Homepage form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Homepage ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}

 genarateKeyBANNER1_IMAGE_URL() {
 var number = Math.floor(100000 + Math.random() * 900000)  
var fileExt = this.fileDataBANNER1_IMAGE_URL.name.split('.').pop();
 var url = this.date11 + number + "." + fileExt
  this.api.onUpload(this.folderName, this.fileDataBANNER1_IMAGE_URL, url)
  //this.data.BANNER1_IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
  this.data.BANNER1_IMAGE_URL =  url;
  return this.data.BANNER1_IMAGE_URL
} 
onFileSelectedBANNER1_IMAGE_URL(event) {
  {
    this.isokfile = true
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!allowed_types.toString().match(event.target.files[0].type)) {
      this.isokfile = false
      this.message.error("Only PNG/JPG/JPEG Images are allowed ", "");
    }

    if (this.isokfile) {
      this.fileDataBANNER1_IMAGE_URL = <File>event.target.files[0];
    }

  }
}
 genarateKeyBANNER2_IMAGE_URL() {
 var number = Math.floor(100000 + Math.random() * 900000)  
var fileExt = this.fileDataBANNER2_IMAGE_URL.name.split('.').pop();
 var url = this.date1 + number + "." + fileExt
  this.api.onUpload(this.folderName, this.fileDataBANNER2_IMAGE_URL, url)
 // this.data.BANNER2_IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
 this.data.BANNER2_IMAGE_URL =  url;
  return this.data.BANNER2_IMAGE_URL
} 
onFileSelectedBANNER2_IMAGE_URL(event) {
  {
    this.isokfile = true
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!allowed_types.toString().match(event.target.files[0].type)) {
      this.isokfile = false
      this.message.error("Only PNG/JPG/JPEG Images are allowed ", "");
    }

    if (this.isokfile) {
      this.fileDataBANNER2_IMAGE_URL = <File>event.target.files[0];
    }

  }


}
 genarateKeyBANNER3_IMAGE_URL() {
 var number = Math.floor(100000 + Math.random() * 900000)  
var fileExt = this.fileDataBANNER3_IMAGE_URL.name.split('.').pop();
 var url = this.date2 + number + "." + fileExt
  this.api.onUpload(this.folderName, this.fileDataBANNER3_IMAGE_URL, url)
 // this.data.BANNER3_IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
 this.data.BANNER3_IMAGE_URL =  url;
  return this.data.BANNER3_IMAGE_URL
} 
onFileSelectedBANNER3_IMAGE_URL(event) {
  {
    this.isokfile = true
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!allowed_types.toString().match(event.target.files[0].type)) {
      this.isokfile = false
      this.message.error("Only PNG/JPG/JPEG Images are allowed ", "");
    }

    if (this.isokfile) {
      this.fileDataBANNER3_IMAGE_URL = <File>event.target.files[0];
    }

  }
}

 clear1()
{
  this.fileDataBANNER1_IMAGE_URL=null
}
clear2()
{
  this.fileDataBANNER2_IMAGE_URL=null
}
clear3()
{
  this.fileDataBANNER3_IMAGE_URL=null
}
}